<?xml version="1.0" ?>
<HED library="score" version="1.0.0">
   <prologue>This schema is a Hierarchical Event Descriptors (HED) Library Schema implementation of Standardized Computer-based Organized Reporting of EEG (SCORE)[1,2] for describing events occurring during neuroimaging time series recordings.
The HED-SCORE library schema allows neurologists, neurophysiologists, and brain researchers to annotate electrophysiology recordings using terms from an internationally accepted set of defined terms (SCORE) compatible with the HED framework.
The resulting annotations are understandable to clinicians and directly usable in computer analysis.
Future extensions may be implemented in the HED-SCORE library schema.
For more information see https://hed-schema-library.readthedocs.io/en/latest/index.html.</prologue>
   <schema>
      <node>
         <name>Modulator</name>
         <description>External stimuli / interventions or changes in the alertness level (sleep) that modify: the background activity, or how often a graphoelement is occurring, or change other features of the graphoelement (like intra-burst frequency). For each observed finding, there is an option of specifying how they are influenced by the modulators and procedures that were done during the recording.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Sleep-modulator</name>
            <node>
               <name>Sleep-deprivation</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sleep-following-sleep-deprivation</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Natural-sleep</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Induced-sleep</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Drowsiness</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Awakening</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Medication-modulator</name>
            <node>
               <name>Medication-administered-during-recording</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Medication-withdrawal-or-reduction-during-recording</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Eye-modulator</name>
            <node>
               <name>Manual-eye-closure</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Manual-eye-opening</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Stimulation-modulator</name>
            <node>
               <name>Intermittent-photic-stimulation</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>numericClass</value>
                  </attribute>
                  <attribute>
                     <name>unitClass</name>
                     <value>frequencyUnits</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Auditory-stimulation</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Nociceptive-stimulation</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Hyperventilation</name>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Physical-effort</name>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Cognitive-task</name>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Other-modulator-or-procedure</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Background-activity</name>
         <description>An EEG activity representing the setting in which a given normal or abnormal pattern appears and from which such pattern is distinguished.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Posterior-dominant-rhythm</name>
            <description>Rhythmic activity occurring during wakefulness over the posterior regions of the head, generally with maximum amplitudes over the occipital areas. Amplitude varies. Best seen with eyes closed and during physical relaxation and relative mental inactivity. Blocked or attenuated by attention, especially visual, and mental effort. In adults this is the alpha rhythm, and the frequency is 8 to 13 Hz. However the frequency can be higher or lower than this range (often a supra or sub harmonic of alpha frequency) and is called alpha variant rhythm (fast and slow alpha variant rhythm). In children, the normal range of the frequency of the posterior dominant rhythm is age-dependant.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Finding-frequency</value>
               <value>Posterior-dominant-rhythm-amplitude-range</value>
               <value>Finding-amplitude-asymmetry</value>
               <value>Posterior-dominant-rhythm-frequency-asymmetry</value>
               <value>Posterior-dominant-rhythm-eye-opening-reactivity</value>
               <value>Posterior-dominant-rhythm-organization</value>
               <value>Posterior-dominant-rhythm-caveat</value>
               <value>Absence-of-posterior-dominant-rhythm</value>
            </attribute>
         </node>
         <node>
            <name>Mu-rhythm</name>
            <description>EEG rhythm at 7-11 Hz composed of arch-shaped waves occurring over the central or centro-parietal regions of the scalp during wakefulness. Amplitudes varies but is mostly below 50 microV. Blocked or attenuated most clearly by contralateral movement, thought of movement, readiness to move or tactile stimulation.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-frequency</value>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
            </attribute>
         </node>
         <node>
            <name>Other-organized-rhythm</name>
            <description>EEG activity that consisting of waves of approximately constant period, which is considered as part of the background (ongoing) activity, but does not fulfill the criteria of the posterior dominant rhythm.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <attribute>
               <name>suggestedTag</name>
               <value>Delta-activity-morphology</value>
               <value>Theta-activity-morphology</value>
               <value>Alpha-activity-morphology</value>
               <value>Beta-activity-morphology</value>
               <value>Gamma-activity-morphology</value>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Background-activity-special-feature</name>
            <description>Special Features. Special features contains scoring options for the background activity of critically ill patients.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Continuous-background-activity</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Delta-activity-morphology</value>
                  <value>Theta-activity-morphology</value>
                  <value>Alpha-activity-morphology</value>
                  <value>Beta-activity-morphology</value>
                  <value>Gamma-activity-morphology</value>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
               </attribute>
            </node>
            <node>
               <name>Nearly-continuous-background-activity</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Delta-activity-morphology</value>
                  <value>Theta-activity-morphology</value>
                  <value>Alpha-activity-morphology</value>
                  <value>Beta-activity-morphology</value>
                  <value>Gamma-activity-morphology</value>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
               </attribute>
            </node>
            <node>
               <name>Discontinuous-background-activity</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Delta-activity-morphology</value>
                  <value>Theta-activity-morphology</value>
                  <value>Alpha-activity-morphology</value>
                  <value>Beta-activity-morphology</value>
                  <value>Gamma-activity-morphology</value>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
               </attribute>
            </node>
            <node>
               <name>Background-burst-suppression</name>
               <description>EEG pattern consisting of bursts (activity appearing and disappearing abruptly) interrupted by periods of low amplitude (below 20 microV) and which occurs simultaneously over all head regions.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
               </attribute>
            </node>
            <node>
               <name>Background-burst-attenuation</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
               </attribute>
            </node>
            <node>
               <name>Background-activity-suppression</name>
               <description>Periods showing activity under 10 microV (referential montage) and interrupting the background (ongoing) activity.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Finding-extent</value>
                  <value>Appearance-mode</value>
               </attribute>
            </node>
            <node>
               <name>Electrocerebral-inactivity</name>
               <description>Absence of any ongoing cortical electric activities; in all leads EEG is isoelectric or only contains artifacts. Sensitivity has to be increased up to 2 microV/mm; recording time: at least 30 minutes.</description>
            </node>
         </node>
      </node>
      <node>
         <name>Sleep-and-drowsiness</name>
         <description>The features of the ongoing activity during sleep are scored here. If abnormal graphoelements appear, disappear or change their morphology during sleep, that is not scored here but at the entry corresponding to that graphooelement (as a modulator).</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Sleep-architecture</name>
            <description>For longer recordings. Only to be scored if whole-night sleep is part of the recording. It is a global descriptor of the structure and pattern of sleep: estimation of the amount of time spent in REM and NREM sleep, sleep duration, NREM-REM cycle.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Property-not-possible-to-determine</value>
            </attribute>
            <node>
               <name>Normal-sleep-architecture</name>
            </node>
            <node>
               <name>Abnormal-sleep-architecture</name>
            </node>
         </node>
         <node>
            <name>Sleep-stage-reached</name>
            <description>For normal sleep patterns the sleep stages reached during the recording can be specified</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <attribute>
               <name>suggestedTag</name>
               <value>Property-not-possible-to-determine</value>
               <value>Finding-significance-to-recording</value>
            </attribute>
            <node>
               <name>Sleep-stage-N1</name>
               <description>Sleep stage 1.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sleep-stage-N2</name>
               <description>Sleep stage 2.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sleep-stage-N3</name>
               <description>Sleep stage 3.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sleep-stage-REM</name>
               <description>Rapid eye movement.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Sleep-spindles</name>
            <description>Burst at 11-15 Hz but mostly at 12-14 Hz generally diffuse but of higher voltage over the central regions of the head, occurring during sleep. Amplitude varies but is mostly below 50 microV in the adult.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>Arousal-pattern</name>
            <description>Arousal pattern in children. Prolonged, marked high voltage 4-6/s activity in all leads with some intermixed slower frequencies, in children.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Frontal-arousal-rhythm</name>
            <description>Prolonged (up to 20s) rhythmical sharp or spiky activity over the frontal areas (maximum over the frontal midline) seen at arousal from sleep in children with minimal cerebral dysfunction.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Vertex-wave</name>
            <description>Sharp potential, maximal at the vertex, negative relative to other areas, apparently occurring spontaneously during sleep or in response to a sensory stimulus during sleep or wakefulness. May be single or repetitive. Amplitude varies but rarely exceeds 250 microV. Abbreviation: V wave. Synonym: vertex sharp wave.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>K-complex</name>
            <description>A burst of somewhat variable appearance, consisting most commonly of a high voltage negative slow wave followed by a smaller positive slow wave frequently associated with a sleep spindle. Duration greater than 0.5 s. Amplitude is generally maximal in the frontal vertex. K complexes occur during nonREM sleep, apparently spontaneously, or in response to sudden sensory / auditory stimuli, and are not specific for any individual sensory modality.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>Saw-tooth-waves</name>
            <description>Vertex negative 2-5 Hz waves occuring in series during REM sleep</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>POSTS</name>
            <description>Positive occipital sharp transients of sleep. Sharp transient maximal over the occipital regions, positive relative to other areas, apparently occurring spontaneously during sleep. May be single or repetitive. Amplitude varies but is generally bellow 50 microV.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>Hypnagogic-hypersynchrony</name>
            <description>Bursts of bilateral, synchronous delta or theta activity of large amplitude, occasionally with superimposed faster components, occurring during falling asleep or during awakening, in children.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-amplitude-asymmetry</value>
            </attribute>
         </node>
         <node>
            <name>Non-reactive-sleep</name>
            <description>EEG activity consisting of normal sleep graphoelements, but which cannot be interrupted by external stimuli/ the patient cannot be waken.</description>
         </node>
      </node>
      <node>
         <name>Interictal-finding</name>
         <description>EEG pattern / transient that is distinguished form the background activity, considered abnormal, but is not recorded during ictal period (seizure) or postictal period; the presence of an interictal finding does not necessarily imply that the patient has epilepsy.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Epileptiform-interictal-activity</name>
            <attribute>
               <name>suggestedTag</name>
               <value>Spike-morphology</value>
               <value>Spike-and-slow-wave-morphology</value>
               <value>Runs-of-rapid-spikes-morphology</value>
               <value>Polyspikes-morphology</value>
               <value>Polyspike-and-slow-wave-morphology</value>
               <value>Sharp-wave-morphology</value>
               <value>Sharp-and-slow-wave-morphology</value>
               <value>Slow-sharp-wave-morphology</value>
               <value>High-frequency-oscillation-morphology</value>
               <value>Hypsarrhythmia-classic-morphology</value>
               <value>Hypsarrhythmia-modified-morphology</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-propagation</value>
               <value>Multifocal-finding</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
               <value>Finding-incidence</value>
            </attribute>
         </node>
         <node>
            <name>Abnormal-interictal-rhythmic-activity</name>
            <attribute>
               <name>suggestedTag</name>
               <value>Delta-activity-morphology</value>
               <value>Theta-activity-morphology</value>
               <value>Alpha-activity-morphology</value>
               <value>Beta-activity-morphology</value>
               <value>Gamma-activity-morphology</value>
               <value>Polymorphic-delta-activity-morphology</value>
               <value>Frontal-intermittent-rhythmic-delta-activity-morphology</value>
               <value>Occipital-intermittent-rhythmic-delta-activity-morphology</value>
               <value>Temporal-intermittent-rhythmic-delta-activity-morphology</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
               <value>Finding-incidence</value>
            </attribute>
         </node>
         <node>
            <name>Interictal-special-patterns</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Interictal-periodic-discharges</name>
               <description>Periodic discharge not further specified (PDs).</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Periodic-discharges-superimposed-activity</value>
                  <value>Periodic-discharge-sharpness</value>
                  <value>Number-of-periodic-discharge-phases</value>
                  <value>Periodic-discharge-triphasic-morphology</value>
                  <value>Periodic-discharge-absolute-amplitude</value>
                  <value>Periodic-discharge-relative-amplitude</value>
                  <value>Periodic-discharge-polarity</value>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Periodic-discharge-duration</value>
                  <value>Periodic-discharge-onset</value>
                  <value>Periodic-discharge-dynamics</value>
               </attribute>
               <node>
                  <name>Generalized-periodic-discharges</name>
                  <description>GPDs.</description>
               </node>
               <node>
                  <name>Lateralized-periodic-discharges</name>
                  <description>LPDs.</description>
               </node>
               <node>
                  <name>Bilateral-independent-periodic-discharges</name>
                  <description>BIPDs.</description>
               </node>
               <node>
                  <name>Multifocal-periodic-discharges</name>
                  <description>MfPDs.</description>
               </node>
            </node>
            <node>
               <name>Extreme-delta-brush</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Appearance-mode</value>
                  <value>Discharge-pattern</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Critically-ill-patients-patterns</name>
         <description>Rhythmic or periodic patterns in critically ill patients (RPPs) are scored according to the 2012 version of the American Clinical Neurophysiology Society Standardized Critical Care EEG Terminology (Hirsch et al., 2013).</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Critically-ill-patients-periodic-discharges</name>
            <description>Periodic discharges (PDs).</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Periodic-discharges-superimposed-activity</value>
               <value>Periodic-discharge-sharpness</value>
               <value>Number-of-periodic-discharge-phases</value>
               <value>Periodic-discharge-triphasic-morphology</value>
               <value>Periodic-discharge-absolute-amplitude</value>
               <value>Periodic-discharge-relative-amplitude</value>
               <value>Periodic-discharge-polarity</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-frequency</value>
               <value>Periodic-discharge-duration</value>
               <value>Periodic-discharge-onset</value>
               <value>Periodic-discharge-dynamics</value>
            </attribute>
         </node>
         <node>
            <name>Rhythmic-delta-activity</name>
            <description>RDA</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Periodic-discharges-superimposed-activity</value>
               <value>Periodic-discharge-absolute-amplitude</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Finding-frequency</value>
               <value>Periodic-discharge-duration</value>
               <value>Periodic-discharge-onset</value>
               <value>Periodic-discharge-dynamics</value>
            </attribute>
         </node>
         <node>
            <name>Spike-or-sharp-and-wave</name>
            <description>SW</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Periodic-discharge-sharpness</value>
               <value>Number-of-periodic-discharge-phases</value>
               <value>Periodic-discharge-triphasic-morphology</value>
               <value>Periodic-discharge-absolute-amplitude</value>
               <value>Periodic-discharge-relative-amplitude</value>
               <value>Periodic-discharge-polarity</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Multifocal-finding</value>
               <value>Finding-frequency</value>
               <value>Periodic-discharge-duration</value>
               <value>Periodic-discharge-onset</value>
               <value>Periodic-discharge-dynamics</value>
            </attribute>
         </node>
      </node>
      <node>
         <name>Episode</name>
         <description>Clinical episode or electrographic seizure.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Epileptic-seizure</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Focal-onset-epileptic-seizure</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Seizure-dynamics</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
               <node>
                  <name>Aware-focal-onset-epileptic-seizure</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-phase</value>
                     <value>Seizure-classification</value>
                     <value>Seizure-dynamics</value>
                     <value>Episode-consciousness</value>
                     <value>Episode-awareness</value>
                     <value>Clinical-EEG-temporal-relationship</value>
                     <value>Episode-event-count</value>
                     <value>State-episode-start</value>
                     <value>Episode-postictal-phase</value>
                     <value>Episode-prodrome</value>
                     <value>Episode-tongue-biting</value>
                  </attribute>
               </node>
               <node>
                  <name>Impaired-awareness-focal-onset-epileptic-seizure</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-phase</value>
                     <value>Seizure-classification</value>
                     <value>Seizure-dynamics</value>
                     <value>Episode-consciousness</value>
                     <value>Episode-awareness</value>
                     <value>Clinical-EEG-temporal-relationship</value>
                     <value>Episode-event-count</value>
                     <value>State-episode-start</value>
                     <value>Episode-postictal-phase</value>
                     <value>Episode-prodrome</value>
                     <value>Episode-tongue-biting</value>
                  </attribute>
               </node>
               <node>
                  <name>Awareness-unknown-focal-onset-epileptic-seizure</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-phase</value>
                     <value>Seizure-classification</value>
                     <value>Seizure-dynamics</value>
                     <value>Episode-consciousness</value>
                     <value>Episode-awareness</value>
                     <value>Clinical-EEG-temporal-relationship</value>
                     <value>Episode-event-count</value>
                     <value>State-episode-start</value>
                     <value>Episode-postictal-phase</value>
                     <value>Episode-prodrome</value>
                     <value>Episode-tongue-biting</value>
                  </attribute>
               </node>
               <node>
                  <name>Focal-to-bilateral-tonic-clonic-focal-onset-epileptic-seizure</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-phase</value>
                     <value>Seizure-dynamics</value>
                     <value>Episode-consciousness</value>
                     <value>Episode-awareness</value>
                     <value>Clinical-EEG-temporal-relationship</value>
                     <value>Episode-event-count</value>
                     <value>State-episode-start</value>
                     <value>Episode-postictal-phase</value>
                     <value>Episode-prodrome</value>
                     <value>Episode-tongue-biting</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Generalized-onset-epileptic-seizure</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Seizure-classification</value>
                  <value>Seizure-dynamics</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Unknown-onset-epileptic-seizure</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Seizure-classification</value>
                  <value>Seizure-dynamics</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Unclassified-epileptic-seizure</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Seizure-dynamics</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Subtle-seizure</name>
            <description>Seizure type frequent in neonates, sometimes referred to as motor automatisms; they may include random and roving eye movements, sucking, chewing motions, tongue protrusion, rowing or swimming or boxing movements of the arms, pedaling and bicycling movements of the lower limbs; apneic seizures are relatively common. Although some subtle seizures are associated with rhythmic ictal EEG discharges, and are clearly epileptic, ictal EEG often does not show typical epileptic activity.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Electrographic-seizure</name>
            <description>Referred usually to non convulsive status. Ictal EEG: rhythmic discharge or spike and wave pattern with definite evolution in frequency, location, or morphology lasting at least 10 s; evolution in amplitude alone did not qualify.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Seizure-PNES</name>
            <description>Psychogenic non-epileptic seizure.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Finding-significance-to-recording</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Sleep-related-episode</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Sleep-related-arousal</name>
               <description>Normal.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Benign-sleep-myoclonus</name>
               <description>A distinctive disorder of sleep characterized by a) neonatal onset, b) rhythmic myoclonic jerks only during sleep and c) abrupt and consistent cessation with arousal, d) absence of concomitant electrographic changes suggestive of seizures, and e) good outcome.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Confusional-awakening</name>
               <description>Episode of non epileptic nature included in NREM parasomnias, characterized by sudden arousal and complex behavior but without full alertness, usually lasting a few minutes and occurring almost in all children at least occasionally. Amnesia of the episode is the rule.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Sleep-periodic-limb-movement</name>
               <description>PLMS. Periodic limb movement in sleep. Episodes are characterized by brief (0.5- to 5.0-second) lower-extremity movements during sleep, which typically occur at 20- to 40-second intervals, most commonly during the first 3 hours of sleep. The affected individual is usually not aware of the movements or of the transient partial arousals.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>REM-sleep-behavioral-disorder</name>
               <description>REM sleep behavioral disorder. Episodes characterized by: a) presence of REM sleep without atonia (RSWA) on polysomnography (PSG); b) presence of at least 1 of the following conditions - (1) Sleep-related behaviors, by history, that have been injurious, potentially injurious, or disruptive (example: dream enactment behavior); (2) abnormal REM sleep behavior documented during PSG monitoring; (3) absence of epileptiform activity on electroencephalogram (EEG) during REM sleep (unless RBD can be clearly distinguished from any concurrent REM sleep-related seizure disorder); (4) sleep disorder not better explained by another sleep disorder, a medical or neurologic disorder, a mental disorder, medication use, or a substance use disorder.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Sleep-walking</name>
               <description>Episodes characterized by ambulation during sleep; the patient is difficult to arouse during an episode, and is usually amnesic following the episode. Episodes usually occur in the first third of the night during slow wave sleep. Polysomnographic recordings demonstrate 2 abnormalities during the first sleep cycle: frequent, brief, non-behavioral EEG-defined arousals prior to the somnambulistic episode and abnormally low gamma (0.75-2.0 Hz) EEG power on spectral analysis, correlating with high-voltage (hyper-synchronic gamma) waves lasting 10 to 15 s occurring just prior to the movement. This is followed by stage I NREM sleep, and there is no evidence of complete awakening.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Pediatric-episode</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Hyperekplexia</name>
               <description>Disorder characterized by exaggerated startle response and hypertonicity that may occur during the first year of life and in severe cases during the neonatal period. Children usually present with marked irritability and recurrent startles in response to handling and sounds. Severely affected infants can have severe jerks and stiffening, sometimes with breath-holding spells.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Jactatio-capitis-nocturna</name>
               <description>Relatively common in normal children at the time of going to bed, especially during the first year of life, the rhythmic head movements persist during sleep. Usually, these phenomena disappear before 3 years of age.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Pavor-nocturnus</name>
               <description>A nocturnal episode characterized by age of onset of less than five years (mean age 18 months, with peak prevalence at five to seven years), appearance of signs of panic two hours after falling asleep with crying, screams, a fearful expression, inability to recognize other people including parents (for a duration of 5-15 minutes), amnesia upon awakening. Pavor nocturnus occurs in patients almost every night for months or years (but the frequency is highly variable and may be as low as once a month) and is likely to disappear spontaneously at the age of six to eight years.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
            <node>
               <name>Pediatric-stereotypical-behavior-episode</name>
               <description>Repetitive motor behavior in children, typically rhythmic and persistent; usually not paroxysmal and rarely suggest epilepsy. They include headbanging, head-rolling, jactatio capitis nocturna, body rocking, buccal or lingual movements, hand flapping and related mannerisms, repetitive hand-waving (to self-induce photosensitive seizures).</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Episode-phase</value>
                  <value>Finding-significance-to-recording</value>
                  <value>Episode-consciousness</value>
                  <value>Episode-awareness</value>
                  <value>Clinical-EEG-temporal-relationship</value>
                  <value>Episode-event-count</value>
                  <value>State-episode-start</value>
                  <value>Episode-postictal-phase</value>
                  <value>Episode-prodrome</value>
                  <value>Episode-tongue-biting</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Paroxysmal-motor-event</name>
            <description>Paroxysmal phenomena during neonatal or childhood periods characterized by recurrent motor or behavioral signs or symptoms that must be distinguishes from epileptic disorders.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Finding-significance-to-recording</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Syncope</name>
            <description>Episode with loss of consciousness and muscle tone that is abrupt in onset, of short duration and followed by rapid recovery; it occurs in response to transient impairment of cerebral perfusion. Typical prodromal symptoms often herald onset of syncope and postictal symptoms are minimal. Syncopal convulsions resulting from cerebral anoxia are common but are not a form of epilepsy, nor are there any accompanying EEG ictal discharges.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Finding-significance-to-recording</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Cataplexy</name>
            <description>A sudden decrement in muscle tone and loss of deep tendon reflexes, leading to muscle weakness, paralysis, or postural collapse. Cataplexy usually is precipitated by an outburst of emotional expression-notably laughter, anger, or startle. It is one of the tetrad of symptoms of narcolepsy. During cataplexy, respiration and voluntary eye movements are not compromised. Consciousness is preserved.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Episode-phase</value>
               <value>Finding-significance-to-recording</value>
               <value>Episode-consciousness</value>
               <value>Episode-awareness</value>
               <value>Clinical-EEG-temporal-relationship</value>
               <value>Episode-event-count</value>
               <value>State-episode-start</value>
               <value>Episode-postictal-phase</value>
               <value>Episode-prodrome</value>
               <value>Episode-tongue-biting</value>
            </attribute>
         </node>
         <node>
            <name>Other-episode</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Physiologic-pattern</name>
         <description>EEG graphoelements or rhythms that are considered normal. They only should be scored if the physician considers that they have a specific clinical significance for the recording.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Rhythmic-activity-pattern</name>
            <description>Not further specified.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Delta-activity-morphology</value>
               <value>Theta-activity-morphology</value>
               <value>Alpha-activity-morphology</value>
               <value>Beta-activity-morphology</value>
               <value>Gamma-activity-morphology</value>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Slow-alpha-variant-rhythm</name>
            <description>Characteristic rhythms mostly at 4-5 Hz, recorded most prominently over the posterior regions of the head. Generally alternate, or are intermixed, with alpha rhythm to which they often are harmonically related. Amplitude varies but is frequently close to 50 micro V. Blocked or attenuated by attention, especially visual, and mental effort. Comment: slow alpha variant rhythms should be distinguished from posterior slow waves characteristic of children and adolescents and occasionally seen in young adults.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Fast-alpha-variant-rhythm</name>
            <description>Characteristic rhythm at 14-20 Hz, detected most prominently over the posterior regions of the head. May alternate or be intermixed with alpha rhythm. Blocked or attenuated by attention, especially visual, and mental effort.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Ciganek-rhythm</name>
            <description>Midline theta rhythm (Ciganek rhythm) may be observed during wakefulness or drowsiness. The frequency is 4-7 Hz, and the location is midline (ie, vertex). The morphology is rhythmic, smooth, sinusoidal, arciform, spiky, or mu-like.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Lambda-wave</name>
            <description>Diphasic sharp transient occurring over occipital regions of the head of waking subjects during visual exploration. The main component is positive relative to other areas. Time-locked to saccadic eye movement. Amplitude varies but is generally below 50 micro V.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Posterior-slow-waves-youth</name>
            <description>Waves in the delta and theta range, of variable form, lasting 0.35 to 0.5 s or longer without any consistent periodicity, found in the range of 6-12 years (occasionally seen in young adults). Alpha waves are almost always intermingled or superimposed. Reactive similar to alpha activity.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Diffuse-slowing-hyperventilation</name>
            <description>Diffuse slowing induced by hyperventilation. Bilateral, diffuse slowing during hyperventilation. Recorded in 70 percent of normal children (3-5 years) and less then 10 percent of adults. Usually appear in the posterior regions and spread forward in younger age group, whereas they tend to appear in the frontal regions and spread backward in the older age group.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Photic-driving</name>
            <description>Physiologic response consisting of rhythmic activity elicited over the posterior regions of the head by repetitive photic stimulation at frequencies of about 5-30 Hz. Comments: term should be limited to activity time-locked to the stimulus and of frequency identical or harmonically related to the stimulus frequency. Photic driving should be distinguished from the visual evoked potentials elicited by isolated flashes of light or flashes repeated at very low frequency.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Photomyogenic-response</name>
            <description>A response to intermittent photic stimulation characterized by the appearance in the record of brief, repetitive muscular artifacts (spikes) over the anterior regions of the head. These often increase gradually in amplitude as stimuli are continued and cease promptly when the stimulus is withdrawn. Comment: this response is frequently associated with flutter of the eyelids and vertical oscillations of the eyeballs and sometimes with discrete jerking mostly involving the musculature of the face and head. (Preferred to synonym: photo-myoclonic response).</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Other-physiologic-pattern</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Uncertain-significant-pattern</name>
         <description>EEG graphoelements or rhythms that resemble abnormal patterns but that are not necessarily associated with a pathology, and the physician does not consider them abnormal in the context of the scored recording (like normal variants and patterns).</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Sharp-transient-pattern</name>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Wicket-spikes</name>
            <description>Spike-like monophasic negative single waves or trains of waves occurring over the temporal regions during drowsiness that have an arcuate or mu-like appearance. These are mainly seen in older individuals and represent a benign variant that is of little clinical significance.</description>
         </node>
         <node>
            <name>Small-sharp-spikes</name>
            <description>Benign epileptiform Transients of Sleep (BETS). Small sharp spikes (SSS) of very short duration and low amplitude, often followed by a small theta wave, occurring in the temporal regions during drowsiness and light sleep. They occur on one or both sides (often asynchronously). The main negative and positive components are of about equally spiky character. Rarely seen in children, they are seen most often in adults and the elderly. Two thirds of the patients have a history of epileptic seizures.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Fourteen-six-Hz-positive-burst</name>
            <description>Burst of arch-shaped waves at 13-17 Hz and/or 5-7-Hz but most commonly at 14 and or 6 Hz seen generally over the posterior temporal and adjacent areas of one or both sides of the head during sleep. The sharp peaks of its component waves are positive with respect to other regions. Amplitude varies but is generally below 75  micro V. Comments: (1) best demonstrated by referential recording using contralateral earlobe or other remote, reference electrodes. (2) This pattern has no established clinical significance.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Six-Hz-spike-slow-wave</name>
            <description>Spike and slow wave complexes at 4-7Hz, but mostly at 6 Hz occurring generally in brief bursts bilaterally and synchronously, symmetrically or asymmetrically, and either confined to or of larger amplitude over the posterior or anterior regions of the head. The spike has a strong positive component. Amplitude varies but is generally smaller than that of spike-and slow-wave complexes repeating at slower rates. Comment: this pattern should be distinguished from epileptiform discharges. Synonym: wave and spike phantom.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Rudimentary-spike-wave-complex</name>
            <description>Synonym: Pseudo petit mal discharge. Paroxysmal discharge that consists of generalized or nearly generalized high voltage 3 to 4/sec waves with poorly developed spike in the positive trough between the slow waves, occurring in drowsiness only. It is found only in infancy and early childhood when marked hypnagogic rhythmical theta activity is paramount in the drowsy state.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Slow-fused-transient</name>
            <description>A posterior slow-wave preceded by a sharp-contoured potential that blends together with the ensuing slow wave, in children.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Needle-like-occipital-spikes-blind</name>
            <description>Spike discharges of a particularly fast and needle-like character develop over the occipital region in most congenitally blind children. Completely disappear during childhood or adolescence.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Subclinical-rhythmic-EEG-discharge-adults</name>
            <description>Subclinical rhythmic EEG discharge of adults (SERDA). A rhythmic pattern seen in the adult age group, mainly in the waking state or drowsiness. It consists of a mixture of frequencies, often predominant in the theta range. The onset may be fairly abrupt with widespread sharp rhythmical theta and occasionally with delta activity. As to the spatial distribution, a maximum of this discharge is usually found over the centroparietal region and especially over the vertex. It may resemble a seizure discharge but is not accompanied by any clinical signs or symptoms.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Rhythmic-temporal-theta-burst-drowsiness</name>
            <description>Rhythmic temporal theta burst of drowsiness (RTTD). Characteristic burst of 4-7 Hz waves frequently notched by faster waves, occurring over the temporal regions of the head during drowsiness. Synonym: psychomotor variant pattern. Comment: this is a pattern of drowsiness that is of no clinical significance.</description>
         </node>
         <node>
            <name>Temporal-slowing-elderly</name>
            <description>Focal theta and/or delta activity over the temporal regions, especially the left, in persons over the age of 60. Amplitudes are low/similar to the background activity. Comment: focal temporal theta was found in 20 percent of people between the ages of 40-59 years, and 40 percent of people between 60 and 79 years. One third of people older than 60 years had focal temporal delta activity.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Breach-rhythm</name>
            <description>Rhythmical activity recorded over cranial bone defects. Usually it is in the 6 to 11/sec range, does not respond to movements.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Brain-laterality</value>
               <value>Brain-region</value>
               <value>Sensors</value>
               <value>Appearance-mode</value>
               <value>Discharge-pattern</value>
            </attribute>
         </node>
         <node>
            <name>Other-uncertain-significant-pattern</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Artifact</name>
         <description>When relevant for the clinical interpretation, artifacts can be scored by specifying the type and the location.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Biological-artifact</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Eye-blink-artifact</name>
               <description>Example for EEG: Fp1/Fp2 become electropositive with eye closure because the cornea is positively charged causing a negative deflection in Fp1/Fp2. If the eye blink is unilateral, consider prosthetic eye. If it is in F8 rather than Fp2 then the electrodes are plugged in wrong.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Eye-movement-horizontal-artifact</name>
               <description>Example for EEG: There is an upward deflection in the Fp2-F8 derivation, when the eyes move to the right side. In this case F8 becomes more positive and therefore. When the eyes move to the left, F7 becomes more positive and there is an upward deflection in the Fp1-F7 derivation.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Eye-movement-vertical-artifact</name>
               <description>Example for EEG: The EEG shows positive potentials (50-100 micro V) with bi-frontal distribution, maximum at Fp1 and Fp2, when the eyeball rotated upward. The downward rotation of the eyeball was associated with the negative deflection. The time course of the deflections was similar to the time course of the eyeball movement.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Slow-eye-movement-artifact</name>
               <description>Slow, rolling eye-movements, seen during drowsiness.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Nystagmus-artifact</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Chewing-artifact</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Sucking-artifact</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Glossokinetic-artifact</name>
               <description>The tongue functions as a dipole, with the tip negative with respect to the base. The artifact produced by the tongue has a broad potential field that drops from frontal to occipital areas, although it is less steep than that produced by eye movement artifacts. The amplitude of the potentials is greater inferiorly than in parasagittal regions; the frequency is variable but usually in the delta range. Chewing and sucking can produce similar artifacts.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Rocking-patting-artifact</name>
               <description>Quasi-rhythmical artifacts in recordings from infants caused by rocking/patting.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Movement-artifact</name>
               <description>Example for EEG: Large amplitude artifact, with irregular morphology (usually resembling a slow-wave or a wave with complex morphology) seen in one or several channels, due to movement. If the causing movement is repetitive, the artifact might resemble a rhythmic EEG activity.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Respiration-artifact</name>
               <description>Respiration can produce 2 kinds of artifacts. One type is in the form of slow and rhythmic activity, synchronous with the body movements of respiration and mechanically affecting the impedance of (usually) one electrode. The other type can be slow or sharp waves that occur synchronously with inhalation or exhalation and involve those electrodes on which the patient is lying.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Pulse-artifact</name>
               <description>Example for EEG: Occurs when an EEG electrode is placed over a pulsating vessel. The pulsation can cause slow waves that may simulate EEG activity. A direct relationship exists between ECG and the pulse waves (200-300 millisecond delay after ECG equals QRS complex).</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>ECG-artifact</name>
               <description>Example for EEG: Far-field potential generated in the heart. The voltage and apparent surface of the artifact vary from derivation to derivation and, consequently, from montage to montage. The artifact is observed best in referential montages using earlobe electrodes A1 and A2. ECG artifact is recognized easily by its rhythmicity/regularity and coincidence with the ECG tracing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Sweat-artifact</name>
               <description>Is a low amplitude undulating waveform that is usually greater than 2 seconds and may appear to be an unstable baseline.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>EMG-artifact</name>
               <description>Myogenic potentials are the most common artifacts. Frontalis and temporalis muscles (ex..: clenching of jaw muscles) are common causes. Generally, the potentials generated in the muscles are of shorter duration than those generated in the brain. The frequency components are usually beyond 30-50 Hz, and the bursts are arrhythmic.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
                  <value>Multifocal-finding</value>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Non-biological-artifact</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Power-supply-artifact</name>
               <description>50-60 Hz artifact. Monomorphic waveform due to 50 or 60 Hz A/C power supply.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Induction-artifact</name>
               <description>Artifacts (usually of high frequency) induced by nearby equipment (like in the intensive care unit).</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Dialysis-artifact</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Artificial-ventilation-artifact</name>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Electrode-pops-artifact</name>
               <description>Are brief discharges with a very steep upslope and shallow fall that occur in all leads which include that electrode.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
            <node>
               <name>Salt-bridge-artifact</name>
               <description>Typically occurs in 1 channel which may appear isoelectric. Only seen in bipolar montage.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Artifact-significance-to-recording</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Other-artifact</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <attribute>
               <name>suggestedTag</name>
               <value>Artifact-significance-to-recording</value>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Polygraphic-channel-finding</name>
         <description>Changes observed in polygraphic channels can be scored: EOG, Respiration, ECG, EMG, other polygraphic channel (+ free text), and their significance logged (normal, abnormal, no definite abnormality).</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>EOG-channel-finding</name>
            <description>ElectroOculoGraphy.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Respiration-channel-finding</name>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
            </attribute>
            <node>
               <name>Respiration-oxygen-saturation</name>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>numericClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Respiration-feature</name>
               <node>
                  <name>Apnoe-respiration</name>
                  <description>Add duration (range in seconds) and comments in free text.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Hypopnea-respiration</name>
                  <description>Add duration (range in seconds) and comments in free text</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Apnea-hypopnea-index-respiration</name>
                  <description>Events/h. Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Periodic-respiration</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Tachypnea-respiration</name>
                  <description>Cycles/min. Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Other-respiration-feature</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>ECG-channel-finding</name>
            <description>Electrocardiography.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
            </attribute>
            <node>
               <name>ECG-QT-period</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>ECG-feature</name>
               <node>
                  <name>ECG-sinus-rhythm</name>
                  <description>Normal rhythm. Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-arrhythmia</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-asystolia</name>
                  <description>Add duration (range in seconds) and comments in free text.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-bradycardia</name>
                  <description>Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-extrasystole</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-ventricular-premature-depolarization</name>
                  <description>Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>ECG-tachycardia</name>
                  <description>Frequency can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Rate-of-change/Frequency</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Other-ECG-feature</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>EMG-channel-finding</name>
            <description>electromyography</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Finding-significance-to-recording</value>
            </attribute>
            <node>
               <name>EMG-muscle-side</name>
               <node>
                  <name>EMG-left-muscle</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>EMG-right-muscle</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>EMG-bilateral-muscle</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>EMG-muscle-name</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>EMG-feature</name>
               <node>
                  <name>EMG-myoclonus</name>
                  <node>
                     <name>Negative-myoclonus</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EMG-myoclonus-rhythmic</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EMG-myoclonus-arrhythmic</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EMG-myoclonus-synchronous</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EMG-myoclonus-asynchronous</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>EMG-PLMS</name>
                  <description>Periodic limb movements in sleep.</description>
               </node>
               <node>
                  <name>EMG-spasm</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>EMG-tonic-contraction</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>EMG-asymmetric-activation</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>EMG-asymmetric-activation-left-first</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EMG-asymmetric-activation-right-first</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Other-EMG-features</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Other-polygraphic-channel</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>#</name>
               <description>Free text.</description>
               <attribute>
                  <name>takesValue</name>
               </attribute>
               <attribute>
                  <name>valueClass</name>
                  <value>textClass</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Finding-property</name>
         <description>Descriptive element similar to main HED /Property. Something that pertains to a thing. A characteristic of some entity. A quality or feature regarded as a characteristic or inherent part of someone or something. HED attributes are adjectives or adverbs.</description>
         <attribute>
            <name>requireChild</name>
         </attribute>
         <node>
            <name>Signal-morphology-property</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Rhythmic-activity-morphology</name>
               <description>EEG activity consisting of a sequence of waves approximately constant period.</description>
               <node>
                  <name>Delta-activity-morphology</name>
                  <description>EEG rhythm in the delta (under 4 Hz) range that does not belong to the posterior dominant rhythm (scored under other organized rhythms).</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                     <value>Finding-amplitude</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Theta-activity-morphology</name>
                  <description>EEG rhythm in the theta (4-8 Hz) range that does not belong to the posterior dominant rhythm (scored under other organized rhythm).</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                     <value>Finding-amplitude</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Alpha-activity-morphology</name>
                  <description>EEG rhythm in the alpha range (8-13 Hz) which is considered part of the background (ongoing) activity but does not fulfill the criteria of the posterior dominant rhythm (alpha rhythm).</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                     <value>Finding-amplitude</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Beta-activity-morphology</name>
                  <description>EEG rhythm between 14 and 40 Hz, which is considered part of the background (ongoing) activity but does not fulfill the criteria of the posterior dominant rhythm. Most characteristically: a rhythm from 14 to 40 Hz recorded over the fronto-central regions of the head during wakefulness. Amplitude of the beta rhythm varies but is mostly below 30 microV. Other beta rhythms are most prominent in other locations or are diffuse.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                     <value>Finding-amplitude</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Gamma-activity-morphology</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                     <value>Finding-amplitude</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Spike-morphology</name>
               <description>A transient, clearly distinguished from background activity, with pointed peak at a conventional paper speed or time scale and duration from 20 to under 70 ms, i.e. 1/50-1/15 s approximately. Main component is generally negative relative to other areas. Amplitude varies.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Spike-and-slow-wave-morphology</name>
               <description>A pattern consisting of a spike followed by a slow wave.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Runs-of-rapid-spikes-morphology</name>
               <description>Bursts of spike discharges at a rate from 10 to 25/sec (in most cases somewhat irregular). The bursts last more than 2 seconds (usually 2 to 10 seconds) and it is typically seen in sleep. Synonyms: rhythmic spikes, generalized paroxysmal fast activity, fast paroxysmal rhythms, grand mal discharge, fast beta activity.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Polyspikes-morphology</name>
               <description>Two or more consecutive spikes.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Polyspike-and-slow-wave-morphology</name>
               <description>Two or more consecutive spikes associated with one or more slow waves.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sharp-wave-morphology</name>
               <description>A transient clearly distinguished from background activity, with pointed peak at a conventional paper speed or time scale, and duration of 70-200 ms, i.e. over 1/4-1/5 s approximately. Main component is generally negative relative to other areas. Amplitude varies.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Sharp-and-slow-wave-morphology</name>
               <description>A sequence of a sharp wave and a slow wave.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Slow-sharp-wave-morphology</name>
               <description>A transient that bears all the characteristics of a sharp-wave, but exceeds 200 ms. Synonym: blunted sharp wave.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>High-frequency-oscillation-morphology</name>
               <description>HFO.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Hypsarrhythmia-classic-morphology</name>
               <description>Abnormal interictal high amplitude waves and a background of irregular spikes.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Hypsarrhythmia-modified-morphology</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Fast-spike-activity-morphology</name>
               <description>A burst consisting of a sequence of spikes. Duration greater than 1 s. Frequency at least in the alpha range.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Low-voltage-fast-activity-morphology</name>
               <description>Refers to the fast, and often recruiting activity which can be recorded at the onset of an ictal discharge, particularly in invasive EEG recording of a seizure.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Polysharp-waves-morphology</name>
               <description>A sequence of two or more sharp-waves.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Slow-wave-large-amplitude-morphology</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Irregular-delta-or-theta-activity-morphology</name>
               <description>EEG activity consisting of repetitive waves of inconsistent wave-duration but in delta and/or theta rang (greater than 125 ms).</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Electrodecremental-change-morphology</name>
               <description>Sudden desynchronization of electrical activity.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>DC-shift-morphology</name>
               <description>Shift of negative polarity of the direct current recordings, during seizures.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Disappearance-of-ongoing-activity-morphology</name>
               <description>Disappearance of the EEG activity that preceded the ictal event but still remnants of background activity (thus not enough to name it electrodecremental change).</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Polymorphic-delta-activity-morphology</name>
               <description>EEG activity consisting of waves in the delta range (over 250 ms duration for each wave) but of different morphology.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Frontal-intermittent-rhythmic-delta-activity-morphology</name>
               <description>Frontal intermittent rhythmic delta activity (FIRDA). Fairly regular or approximately sinusoidal waves, mostly occurring in bursts at 1.5-2.5 Hz over the frontal areas of one or both sides of the head. Comment: most commonly associated with unspecified encephalopathy, in adults.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Occipital-intermittent-rhythmic-delta-activity-morphology</name>
               <description>Occipital intermittent rhythmic delta activity (OIRDA). Fairly regular or approximately sinusoidal waves, mostly occurring in bursts at 2-3 Hz over the occipital or posterior head regions of one or both sides of the head. Frequently blocked or attenuated by opening the eyes. Comment: most commonly associated with unspecified encephalopathy, in children.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Temporal-intermittent-rhythmic-delta-activity-morphology</name>
               <description>Temporal intermittent rhythmic delta activity (TIRDA). Fairly regular or approximately sinusoidal waves, mostly occurring in bursts at over the temporal areas of one side of the head. Comment: most commonly associated with temporal lobe epilepsy.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Periodic-discharges-morphology</name>
               <description>Periodic discharges not further specified (PDs).</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Periodic-discharges-superimposed-activity</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Periodic-discharges-fast-superimposed-activity</name>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Finding-frequency</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Periodic-discharges-rhythmic-superimposed-activity</name>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Finding-frequency</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-sharpness</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Spiky-periodic-discharge-sharpness</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Sharp-periodic-discharge-sharpness</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Sharply-contoured-periodic-discharge-sharpness</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Blunt-periodic-discharge-sharpness</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Number-of-periodic-discharge-phases</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>1-periodic-discharge-phase</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>2-periodic-discharge-phases</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>3-periodic-discharge-phases</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Greater-than-3-periodic-discharge-phases</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-triphasic-morphology</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                     <value>Property-exists</value>
                     <value>Property-absence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-absolute-amplitude</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Periodic-discharge-absolute-amplitude-very-low</name>
                     <description>Lower than 20 microV.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Low-periodic-discharge-absolute-amplitude</name>
                     <description>20 to 49 microV.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Medium-periodic-discharge-absolute-amplitude</name>
                     <description>50 to 199 microV.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>High-periodic-discharge-absolute-amplitude</name>
                     <description>Greater than 200 microV.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-relative-amplitude</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Periodic-discharge-relative-amplitude-less-than-equal-2</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Periodic-discharge-relative-amplitude-greater-than-2</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-polarity</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>Periodic-discharge-postitive-polarity</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Periodic-discharge-negative-polarity</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Periodic-discharge-unclear-polarity</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Source-analysis-property</name>
            <description>How the current in the brain reaches the electrode sensors.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Source-analysis-laterality</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Brain-laterality</value>
               </attribute>
            </node>
            <node>
               <name>Source-analysis-brain-region</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Source-analysis-frontal-perisylvian-superior-surface</name>
               </node>
               <node>
                  <name>Source-analysis-frontal-lateral</name>
               </node>
               <node>
                  <name>Source-analysis-frontal-mesial</name>
               </node>
               <node>
                  <name>Source-analysis-frontal-polar</name>
               </node>
               <node>
                  <name>Source-analysis-frontal-orbitofrontal</name>
               </node>
               <node>
                  <name>Source-analysis-temporal-polar</name>
               </node>
               <node>
                  <name>Source-analysis-temporal-basal</name>
               </node>
               <node>
                  <name>Source-analysis-temporal-lateral-anterior</name>
               </node>
               <node>
                  <name>Source-analysis-temporal-lateral-posterior</name>
               </node>
               <node>
                  <name>Source-analysis-temporal-perisylvian-inferior-surface</name>
               </node>
               <node>
                  <name>Source-analysis-central-lateral-convexity</name>
               </node>
               <node>
                  <name>Source-analysis-central-mesial</name>
               </node>
               <node>
                  <name>Source-analysis-central-sulcus-anterior-surface</name>
               </node>
               <node>
                  <name>Source-analysis-central-sulcus-posterior-surface</name>
               </node>
               <node>
                  <name>Source-analysis-central-opercular</name>
               </node>
               <node>
                  <name>Source-analysis-parietal-lateral-convexity</name>
               </node>
               <node>
                  <name>Source-analysis-parietal-mesial</name>
               </node>
               <node>
                  <name>Source-analysis-parietal-opercular</name>
               </node>
               <node>
                  <name>Source-analysis-occipital-lateral</name>
               </node>
               <node>
                  <name>Source-analysis-occipital-mesial</name>
               </node>
               <node>
                  <name>Source-analysis-occipital-basal</name>
               </node>
               <node>
                  <name>Source-analysis-insula</name>
               </node>
            </node>
         </node>
         <node>
            <name>Location-property</name>
            <description>Location can be scored for findings. Semiologic finding can also be characterized by the somatotopic modifier (i.e. the part of the body where it occurs). In this respect, laterality (left, right, symmetric, asymmetric, left greater than right, right greater than left), body part (eyelid, face, arm, leg, trunk, visceral, hemi-) and centricity (axial, proximal limb, distal limb) can be scored.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Brain-laterality</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Brain-laterality-left</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-laterality-left-greater-right</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-laterality-right</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-laterality-right-greater-left</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-laterality-midline</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-laterality-diffuse-asynchronous</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Brain-region</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Brain-region-frontal</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-region-temporal</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-region-central</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-region-parietal</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-region-occipital</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Body-part-location</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Eyelid-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Face-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Arm-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Leg-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Trunk-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Visceral-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Hemi-location</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Brain-centricity</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Brain-centricity-axial</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-centricity-proximal-limb</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Brain-centricity-distal-limb</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Sensors</name>
               <description>Lists all corresponding sensors (electrodes/channels in montage). The sensor-group is selected from a list defined in the site-settings for each EEG-lab.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-propagation</name>
               <description>When propagation within the graphoelement is observed, first the location of the onset region is scored. Then, the location of the propagation can be noted.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-exists</value>
                  <value>Property-absence</value>
                  <value>Brain-laterality</value>
                  <value>Brain-region</value>
                  <value>Sensors</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Multifocal-finding</name>
               <description>When the same interictal graphoelement is observed bilaterally and at least in three independent locations, can score them using one entry, and choosing multifocal as a descriptor of the locations of the given interictal graphoelements, optionally emphasizing the involved, and the most active sites.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Property-exists</value>
                  <value>Property-absence</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Modulators-property</name>
            <description>For each described graphoelement, the influence of the modulators can be scored. Only modulators present in the recording are scored.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Modulators-reactivity</name>
               <description>Susceptibility of individual rhythms or the EEG as a whole to change following sensory stimulation or other physiologic actions.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-exists</value>
                  <value>Property-absence</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Eye-closure-sensitivity</name>
               <description>Eye closure sensitivity.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-exists</value>
                  <value>Property-absence</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Eye-opening-passive</name>
               <description>Passive eye opening. Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
                  <value>Finding-triggered-by</value>
               </attribute>
            </node>
            <node>
               <name>Medication-effect-EEG</name>
               <description>Medications effect on EEG. Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
               </attribute>
            </node>
            <node>
               <name>Medication-reduction-effect-EEG</name>
               <description>Medications reduction or withdrawal effect on EEG. Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
               </attribute>
            </node>
            <node>
               <name>Auditive-stimuli-effect</name>
               <description>Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
               </attribute>
            </node>
            <node>
               <name>Nociceptive-stimuli-effect</name>
               <description>Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
                  <value>Finding-triggered-by</value>
               </attribute>
            </node>
            <node>
               <name>Physical-effort-effect</name>
               <description>Used with base schema Increasing/Decreasing</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
                  <value>Finding-triggered-by</value>
               </attribute>
            </node>
            <node>
               <name>Cognitive-task-effect</name>
               <description>Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
                  <value>Finding-triggered-by</value>
               </attribute>
            </node>
            <node>
               <name>Other-modulators-effect-EEG</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Facilitating-factor</name>
               <description>Facilitating factors are defined as transient and sporadic endogenous or exogenous elements capable of augmenting seizure incidence (increasing the likelihood of seizure occurrence).</description>
               <node>
                  <name>Facilitating-factor-alcohol</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-awake</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-catamenial</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-fever</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-sleep</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-sleep-deprived</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Facilitating-factor-other</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Provocative-factor</name>
               <description>Provocative factors are defined as transient and sporadic endogenous or exogenous elements capable of evoking/triggering seizures immediately following the exposure to it.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Hyperventilation-provoked</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Reflex-provoked</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Medication-effect-clinical</name>
               <description>Medications clinical effect. Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
               </attribute>
            </node>
            <node>
               <name>Medication-reduction-effect-clinical</name>
               <description>Medications reduction or withdrawal clinical effect. Used with base schema Increasing/Decreasing.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Finding-stopped-by</value>
                  <value>Finding-unmodified</value>
               </attribute>
            </node>
            <node>
               <name>Other-modulators-effect-clinical</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Intermittent-photic-stimulation-effect</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Posterior-stimulus-dependent-intermittent-photic-stimulation-response</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-stimulus-independent-intermittent-photic-stimulation-response-limited</name>
                  <description>limited to the stimulus-train</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-stimulus-independent-intermittent-photic-stimulation-response-self-sustained</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Generalized-photoparoxysmal-intermittent-photic-stimulation-response-limited</name>
                  <description>Limited to the stimulus-train.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Generalized-photoparoxysmal-intermittent-photic-stimulation-response-self-sustained</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Activation-of-pre-existing-epileptogenic-area-intermittent-photic-stimulation-effect</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Unmodified-intermittent-photic-stimulation-effect</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Quality-of-hyperventilation</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Hyperventilation-refused-procedure</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Hyperventilation-poor-effort</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Hyperventilation-good-effort</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Hyperventilation-excellent-effort</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Modulators-effect</name>
               <description>Tags for describing the influence of the modulators</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Modulators-effect-continuous-during-NRS</name>
                  <description>Continuous during non-rapid-eye-movement-sleep (NRS)</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Modulators-effect-only-during</name>
                  <node>
                     <name>#</name>
                     <description>Only during Sleep/Awakening/Hyperventilation/Physical effort/Cognitive task. Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Modulators-effect-change-of-patterns</name>
                  <description>Change of patterns during sleep/awakening.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Time-related-property</name>
            <description>Important to estimate how often an interictal abnormality is seen in the recording.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Appearance-mode</name>
               <description>Describes how the non-ictal EEG pattern/graphoelement is distributed through the recording.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
               </attribute>
               <node>
                  <name>Random-appearance-mode</name>
                  <description>Occurrence of the non-ictal EEG pattern / graphoelement without any rhythmicity / periodicity.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Periodic-appearance-mode</name>
                  <description>Non-ictal EEG pattern / graphoelement occurring at an approximately regular rate / interval (generally of 1 to several seconds).</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Variable-appearance-mode</name>
                  <description>Occurrence of non-ictal EEG pattern / graphoelements, that is sometimes rhythmic or periodic, other times random, throughout the recording.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Intermittent-appearance-mode</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Continuous-appearance-mode</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Discharge-pattern</name>
               <description>Describes the organization of the EEG signal within the discharge (distinguish between single and repetitive discharges)</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Single-discharge-pattern</name>
                  <description>Applies to the intra-burst pattern: a graphoelement that is not repetitive; before and after the graphoelement one can distinguish the background activity.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-incidence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Rhythmic-trains-or-bursts-discharge-pattern</name>
                  <description>Applies to the intra-burst pattern: a non-ictal graphoelement that repeats itself without returning to the background activity between them. The graphoelements within this repetition occur at approximately constant period.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-prevalence</value>
                     <value>Finding-frequency</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Arrhythmic-trains-or-bursts-discharge-pattern</name>
                  <description>Applies to the intra-burst pattern: a non-ictal graphoelement that repeats itself without returning to the background activity between them. The graphoelements within this repetition occur at inconstant period.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Finding-prevalence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Fragmented-discharge-pattern</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Periodic-discharge-time-related-features</name>
               <description>Periodic discharges not further specified (PDs) time-relayed features tags.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Periodic-discharge-duration</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Very-brief-periodic-discharge-duration</name>
                     <description>Less than 10 sec.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Brief-periodic-discharge-duration</name>
                     <description>10 to 59 sec.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Intermediate-periodic-discharge-duration</name>
                     <description>1 to 4.9 min.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Long-periodic-discharge-duration</name>
                     <description>5 to 59 min.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Very-long-periodic-discharge-duration</name>
                     <description>Greater than 1 hour.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-onset</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Sudden-periodic-discharge-onset</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Gradual-periodic-discharge-onset</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Periodic-discharge-dynamics</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Evolving-periodic-discharge-dynamics</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Fluctuating-periodic-discharge-dynamics</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Static-periodic-discharge-dynamics</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
            </node>
            <node>
               <name>Finding-extent</name>
               <description>Percentage of occurrence during the recording (background activity and interictal finding).</description>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>numericClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-incidence</name>
               <description>How often it occurs/time-epoch.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Only-once-finding-incidence</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Rare-finding-incidence</name>
                  <description>less than 1/h</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Uncommon-finding-incidence</name>
                  <description>1/5 min to 1/h.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Occasional-finding-incidence</name>
                  <description>1/min to 1/5min.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Frequent-finding-incidence</name>
                  <description>1/10 s to 1/min.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Abundant-finding-incidence</name>
                  <description>Greater than 1/10 s).</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Finding-prevalence</name>
               <description>The percentage of the recording covered by the train/burst.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Rare-finding-prevalence</name>
                  <description>Less than 1 percent.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Occasional-finding-prevalence</name>
                  <description>1 to 9 percent.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Frequent-finding-prevalence</name>
                  <description>10 to 49 percent.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Abundant-finding-prevalence</name>
                  <description>50 to 89 percent.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Continuous-finding-prevalence</name>
                  <description>Greater than 90 percent.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Posterior-dominant-rhythm-property</name>
            <description>Posterior dominant rhythm is the most often scored EEG feature in clinical practice. Therefore, there are specific terms that can be chosen for characterizing the PDR.</description>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Posterior-dominant-rhythm-amplitude-range</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
               </attribute>
               <node>
                  <name>Low-posterior-dominant-rhythm-amplitude-range</name>
                  <description>Low (less than 20 microV).</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Medium-posterior-dominant-rhythm-amplitude-range</name>
                  <description>Medium (between 20 and 70 microV).</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>High-posterior-dominant-rhythm-amplitude-range</name>
                  <description>High (more than 70 microV).</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Posterior-dominant-rhythm-frequency-asymmetry</name>
               <description>When symmetrical could be labeled with base schema Symmetrical tag.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Posterior-dominant-rhythm-frequency-asymmetry-lower-left</name>
                  <description>Hz lower on the left side.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-frequency-asymmetry-lower-right</name>
                  <description>Hz lower on the right side.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Posterior-dominant-rhythm-eye-opening-reactivity</name>
               <description>Change (disappearance or measurable decrease in amplitude) of a posterior dominant rhythm following eye-opening. Eye closure has the opposite effect.</description>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
               </attribute>
               <node>
                  <name>Posterior-dominant-rhythm-eye-opening-reactivity-reduced-left</name>
                  <description>Reduced left side reactivity.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-eye-opening-reactivity-reduced-right</name>
                  <description>Reduced right side reactivity.</description>
                  <node>
                     <name>#</name>
                     <description>free text</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-eye-opening-reactivity-reduced-both</name>
                  <description>Reduced reactivity on both sides.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Posterior-dominant-rhythm-organization</name>
               <description>When normal could be labeled with base schema Normal tag.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Posterior-dominant-rhythm-organization-poorly-organized</name>
                  <description>Poorly organized.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-organization-disorganized</name>
                  <description>Disorganized.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-organization-markedly-disorganized</name>
                  <description>Markedly disorganized.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Posterior-dominant-rhythm-caveat</name>
               <description>Caveat to the annotation of PDR.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>No-posterior-dominant-rhythm-caveat</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-caveat-only-open-eyes-during-the-recording</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-caveat-sleep-deprived-caveat</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-caveat-drowsy</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Posterior-dominant-rhythm-caveat-only-following-hyperventilation</name>
               </node>
            </node>
            <node>
               <name>Absence-of-posterior-dominant-rhythm</name>
               <description>Reason for absence of PDR.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-artifacts</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-extreme-low-voltage</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-eye-closure-could-not-be-achieved</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-lack-of-awake-period</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-lack-of-compliance</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Absence-of-posterior-dominant-rhythm-other-causes</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Episode-property</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Seizure-classification</name>
               <description>Epileptic seizures are named using the current ILAE seizure classification (Fisher et al., 2017, Beniczky et al., 2017).</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Motor-onset-seizure</name>
                  <node>
                     <name>Myoclonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Negative-myoclonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Clonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Tonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Atonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Myoclonic-atonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Myoclonic-tonic-clonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Tonic-clonic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Automatism-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Hyperkinetic-motor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Epileptic-spasm-episode</name>
                  </node>
               </node>
               <node>
                  <name>Nonmotor-onset-seizure</name>
                  <node>
                     <name>Behavior-arrest-nonmotor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Sensory-nonmotor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Emotional-nonmotor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Cognitive-nonmotor-onset-seizure</name>
                  </node>
                  <node>
                     <name>Autonomic-nonmotor-onset-seizure</name>
                  </node>
               </node>
               <node>
                  <name>Absence-seizure</name>
                  <node>
                     <name>Typical-absence-seizure</name>
                  </node>
                  <node>
                     <name>Atypical-absence-seizure</name>
                  </node>
                  <node>
                     <name>Myoclonic-absence-seizure</name>
                  </node>
                  <node>
                     <name>Eyelid-myoclonia-absence-seizure</name>
                  </node>
               </node>
            </node>
            <node>
               <name>Episode-phase</name>
               <description>The electroclinical findings (i.e., the seizure semiology and the ictal EEG) are divided in three phases: onset, propagation, and postictal.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Seizure-semiology-manifestation</value>
                  <value>Postictal-semiology-manifestation</value>
                  <value>Ictal-EEG-patterns</value>
               </attribute>
               <node>
                  <name>Episode-phase-initial</name>
               </node>
               <node>
                  <name>Episode-phase-subsequent</name>
               </node>
               <node>
                  <name>Episode-phase-postictal</name>
               </node>
            </node>
            <node>
               <name>Seizure-semiology-manifestation</name>
               <description>Semiology is described according to the ILAE Glossary of Descriptive Terminology for Ictal Semiology (Blume et al., 2001). Besides the name, the semiologic finding can also be characterized by the somatotopic modifier, laterality, body part and centricity. Uses Location-property tags.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Semiology-motor-manifestation</name>
                  <node>
                     <name>Semiology-elementary-motor</name>
                     <node>
                        <name>Semiology-motor-tonic</name>
                        <description>A sustained increase in muscle contraction lasting a few seconds to minutes.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-dystonic</name>
                        <description>Sustained contractions of both agonist and antagonist muscles producing athetoid or twisting movements, which, when prolonged, may produce abnormal postures.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-epileptic-spasm</name>
                        <description>A sudden flexion, extension, or mixed extension flexion of predominantly proximal and truncal muscles that is usually more sustained than a myoclonic movement but not so sustained as a tonic seizure (i.e., about 1 s). Limited forms may occur: grimacing, head nodding. Frequent occurrence in clusters.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-postural</name>
                        <description>Adoption of a posture that may be bilaterally symmetric or asymmetric (as in a fencing posture).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-versive</name>
                        <description>A sustained, forced conjugate ocular, cephalic, and/or truncal rotation or lateral deviation from the midline.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Body-part-location</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-clonic</name>
                        <description>Myoclonus that is regularly repetitive, involves the same muscle groups, at a frequency of about 2 to 3 c/s, and is prolonged. Synonym: rhythmic myoclonus .</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-myoclonic</name>
                        <description>Characterized by myoclonus. MYOCLONUS : sudden, brief (lower than 100 ms) involuntary single or multiple contraction(s) of muscles(s) or muscle groups of variable topography (axial, proximal limb, distal).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-jacksonian-march</name>
                        <description>Term indicating spread of clonic movements through contiguous body parts unilaterally.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-negative-myoclonus</name>
                        <description>Characterized by negative myoclonus. NEGATIVE MYOCLONUS: interruption of tonic muscular activity for lower than 500 ms without evidence of preceding myoclonia.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-tonic-clonic</name>
                        <description>A sequence consisting of a tonic followed by a clonic phase. Variants such as clonic-tonic-clonic may be seen. Asymmetry of limb posture during the tonic phase of a GTC: one arm is rigidly extended at the elbow (often with the fist clenched tightly and flexed at the wrist), whereas the opposite arm is flexed at the elbow.</description>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>Semiology-motor-tonic-clonic-without-figure-of-four</name>
                           <attribute>
                              <name>suggestedTag</name>
                              <value>Brain-laterality</value>
                              <value>Body-part-location</value>
                              <value>Brain-centricity</value>
                              <value>Episode-event-count</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Semiology-motor-tonic-clonic-with-figure-of-four-extension-left-elbow</name>
                           <attribute>
                              <name>suggestedTag</name>
                              <value>Brain-laterality</value>
                              <value>Body-part-location</value>
                              <value>Brain-centricity</value>
                              <value>Episode-event-count</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Semiology-motor-tonic-clonic-with-figure-of-four-extension-right-elbow</name>
                           <attribute>
                              <name>suggestedTag</name>
                              <value>Brain-laterality</value>
                              <value>Body-part-location</value>
                              <value>Brain-centricity</value>
                              <value>Episode-event-count</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Semiology-motor-astatic</name>
                        <description>Loss of erect posture that results from an atonic, myoclonic, or tonic mechanism. Synonym: drop attack.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-atonic</name>
                        <description>Sudden loss or diminution of muscle tone without apparent preceding myoclonic or tonic event lasting greater or equal to 1 to 2 s, involving head, trunk, jaw, or limb musculature.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-eye-blinking</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-other-elementary-motor</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Semiology-motor-automatisms</name>
                     <node>
                        <name>Semiology-motor-automatisms-mimetic</name>
                        <description>Facial expression suggesting an emotional state, often fear.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-oroalimentary</name>
                        <description>Lip smacking, lip pursing, chewing, licking, tooth grinding, or swallowing.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-dacrystic</name>
                        <description>Bursts of crying.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-dyspraxic</name>
                        <description>Inability to perform learned movements spontaneously or on command or imitation despite intact relevant motor and sensory systems and adequate comprehension and cooperation.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-manual</name>
                        <description>1. Indicates principally distal components, bilateral or unilateral. 2. Fumbling, tapping, manipulating movements.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Brain-centricity</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-gestural</name>
                        <description>Semipurposive, asynchronous hand movements. Often unilateral.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-pedal</name>
                        <description>1. Indicates principally distal components, bilateral or unilateral. 2. Fumbling, tapping, manipulating movements.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Brain-centricity</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-hypermotor</name>
                        <description>1. Involves predominantly proximal limb or axial muscles producing irregular sequential ballistic movements, such as pedaling, pelvic thrusting, thrashing, rocking movements. 2. Increase in rate of ongoing movements or inappropriately rapid performance of a movement.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-hypokinetic</name>
                        <description>A decrease in amplitude and/or rate or arrest of ongoing motor activity.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-automatisms-gelastic</name>
                        <description>Bursts of laughter or giggling, usually without an appropriate affective tone.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-responsiveness</value>
                           <value>Episode-appearance</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-motor-other-automatisms</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Semiology-motor-behavioral-arrest</name>
                     <description>Interruption of ongoing motor activity or of ongoing behaviors with fixed gaze, without movement of the head or trunk (oro-alimentary and hand automatisms may continue).</description>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Brain-laterality</value>
                        <value>Body-part-location</value>
                        <value>Brain-centricity</value>
                        <value>Episode-event-count</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Semiology-non-motor-manifestation</name>
                  <node>
                     <name>Semiology-sensory</name>
                     <node>
                        <name>Semiology-sensory-headache</name>
                        <description>Headache occurring in close temporal proximity to the seizure or as the sole seizure manifestation.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-visual</name>
                        <description>Flashing or flickering lights, spots, simple patterns, scotomata, or amaurosis.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-auditory</name>
                        <description>Buzzing, drumming sounds or single tones.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-olfactory</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Body-part-location</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-gustatory</name>
                        <description>Taste sensations including acidic, bitter, salty, sweet, or metallic.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-epigastric</name>
                        <description>Abdominal discomfort including nausea, emptiness, tightness, churning, butterflies, malaise, pain, and hunger; sensation may rise to chest or throat. Some phenomena may reflect ictal autonomic dysfunction.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-somatosensory</name>
                        <description>Tingling, numbness, electric-shock sensation, sense of movement or desire to move.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-painful</name>
                        <description>Peripheral (lateralized/bilateral), cephalic, abdominal.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Body-part-location</value>
                           <value>Brain-centricity</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-autonomic-sensation</name>
                        <description>A sensation consistent with involvement of the autonomic nervous system, including cardiovascular, gastrointestinal,  sudomotor, vasomotor, and thermoregulatory functions. (Thus autonomic aura; cf. autonomic events  3.0).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-sensory-other</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Semiology-experiential</name>
                     <node>
                        <name>Semiology-experiential-affective-emotional</name>
                        <description>Components include fear, depression, joy, and (rarely) anger.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-experiential-hallucinatory</name>
                        <description>Composite perceptions without corresponding external stimuli involving visual, auditory, somatosensory, olfactory, and/or gustatory phenomena. Example: hearing  and seeing  people talking.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-experiential-illusory</name>
                        <description>An alteration of actual percepts involving the visual, auditory, somatosensory, olfactory, or gustatory systems.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-experiential-mnemonic</name>
                        <description>Components that reflect ictal dysmnesia such as feelings of familiarity (deja-vu) and unfamiliarity (jamais-vu).</description>
                        <node>
                           <name>Semiology-experiential-mnemonic-Deja-vu</name>
                           <attribute>
                              <name>suggestedTag</name>
                              <value>Episode-event-count</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Semiology-experiential-mnemonic-Jamais-vu</name>
                           <attribute>
                              <name>suggestedTag</name>
                              <value>Episode-event-count</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Semiology-experiential-other</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Semiology-dyscognitive</name>
                     <description>The term describes events in which (1) disturbance of cognition is the predominant or most apparent feature, and (2a) two or more of the following components are involved, or (2b) involvement of such components remains undetermined. Otherwise, use the more specific term (e.g., mnemonic experiential seizure  or hallucinatory experiential seizure). Components of cognition: ++ perception: symbolic conception of sensory information ++ attention: appropriate selection of a principal perception or task ++ emotion: appropriate affective significance of a perception ++ memory: ability to store and retrieve percepts or concepts ++ executive function: anticipation, selection, monitoring of consequences, and initiation of motor activity including praxis, speech.</description>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Episode-event-count</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Semiology-language-related</name>
                     <node>
                        <name>Semiology-language-related-vocalization</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-language-related-verbalization</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-language-related-dysphasia</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-language-related-aphasia</name>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-language-related-other</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Semiology-autonomic</name>
                     <node>
                        <name>Semiology-autonomic-pupillary</name>
                        <description>Mydriasis, miosis (either bilateral or unilateral).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-hypersalivation</name>
                        <description>Increase in production of saliva leading to uncontrollable drooling</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-respiratory-apnoeic</name>
                        <description>subjective shortness of breath, hyperventilation, stridor, coughing, choking, apnea, oxygen desaturation, neurogenic pulmonary edema.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-cardiovascular</name>
                        <description>Modifications of heart rate (tachycardia, bradycardia), cardiac arrhythmias (such as sinus arrhythmia, sinus arrest, supraventricular tachycardia, atrial premature depolarizations, ventricular premature depolarizations, atrio-ventricular block, bundle branch block, atrioventricular nodal escape rhythm, asystole).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-gastrointestinal</name>
                        <description>Nausea, eructation, vomiting, retching, abdominal sensations, abdominal pain, flatulence, spitting, diarrhea.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-urinary-incontinence</name>
                        <description>urinary urge (intense urinary urge at the beginning of seizures), urinary incontinence, ictal urination (rare symptom of partial seizures without loss of consciousness).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-genital</name>
                        <description>Sexual auras (erotic thoughts and feelings, sexual arousal and orgasm). Genital auras (unpleasant, sometimes painful, frightening or emotionally neutral somatosensory sensations in the genitals that can be accompanied by ictal orgasm). Sexual automatisms (hypermotor movements consisting of writhing, thrusting, rhythmic movements of the pelvis, arms and legs, sometimes associated with picking and rhythmic manipulation of the groin or genitalia, exhibitionism and masturbation).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-vasomotor</name>
                        <description>Flushing or pallor (may be accompanied by feelings of warmth, cold and pain).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-sudomotor</name>
                        <description>Sweating and piloerection (may be accompanied by feelings of warmth, cold and pain).</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Brain-laterality</value>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-thermoregulatory</name>
                        <description>Hyperthermia, fever.</description>
                        <attribute>
                           <name>suggestedTag</name>
                           <value>Episode-event-count</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Semiology-autonomic-other</name>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>Free text.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>textClass</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Semiology-manifestation-other</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Postictal-semiology-manifestation</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Postictal-semiology-unconscious</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-quick-recovery-of-consciousness</name>
                  <description>Quick recovery of awareness and responsiveness.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-aphasia-or-dysphasia</name>
                  <description>Impaired communication involving language without dysfunction of relevant primary motor or sensory pathways, manifested as impaired comprehension, anomia, parahasic errors or a combination of these.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-behavioral-change</name>
                  <description>Occurring immediately after a aseizure. Including psychosis, hypomanina, obsessive-compulsive behavior.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-hemianopia</name>
                  <description>Postictal visual loss in a a hemi field.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Brain-laterality</value>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-impaired-cognition</name>
                  <description>Decreased Cognitive performance involving one or more of perception, attention, emotion, memory, execution, praxis, speech.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-dysphoria</name>
                  <description>Depression, irritability, euphoric mood, fear, anxiety.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-headache</name>
                  <description>Headache with features of tension-type or migraine headache that develops within 3 h following the seizure and resolves within 72 h after seizure.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-nose-wiping</name>
                  <description>Noes-wiping usually within 60 sec of seizure offset, usually with the hand ipsilateral to the seizure onset.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Brain-laterality</value>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-anterograde-amnesia</name>
                  <description>Impaired ability to remember new material.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-retrograde-amnesia</name>
                  <description>Impaired ability to recall previously remember material.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-paresis</name>
                  <description>Todds palsy. Any unilateral postictal dysfunction relating to motor, language, sensory and/or integrative functions.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Brain-laterality</value>
                     <value>Body-part-location</value>
                     <value>Brain-centricity</value>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-semiology-sleep</name>
                  <description>Invincible need to sleep after a seizure.</description>
               </node>
               <node>
                  <name>Postictal-semiology-unilateral-myoclonic-jerks</name>
                  <description>unilateral motor phenomena, other then  specified, occurring in postictal phase.</description>
               </node>
               <node>
                  <name>Postictal-semiology-other-unilateral-motor-phenomena</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Polygraphic-channel-relation-to-episode</name>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>suggestedTag</name>
                  <value>Property-not-possible-to-determine</value>
               </attribute>
               <node>
                  <name>Polygraphic-channel-cause-to-episode</name>
               </node>
               <node>
                  <name>Polygraphic-channel-consequence-of-episode</name>
               </node>
            </node>
            <node>
               <name>Ictal-EEG-patterns</name>
               <node>
                  <name>Ictal-EEG-patterns-obscured-by-artifacts</name>
                  <description>The interpretation of the EEG is not possible due to artifacts.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Ictal-EEG-activity</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Polyspikes-morphology</value>
                     <value>Fast-spike-activity-morphology</value>
                     <value>Low-voltage-fast-activity-morphology</value>
                     <value>Polysharp-waves-morphology</value>
                     <value>Spike-and-slow-wave-morphology</value>
                     <value>Polyspike-and-slow-wave-morphology</value>
                     <value>Sharp-and-slow-wave-morphology</value>
                     <value>Rhythmic-activity-morphology</value>
                     <value>Slow-wave-large-amplitude-morphology</value>
                     <value>Irregular-delta-or-theta-activity-morphology</value>
                     <value>Electrodecremental-change-morphology</value>
                     <value>DC-shift-morphology</value>
                     <value>Disappearance-of-ongoing-activity-morphology</value>
                     <value>Brain-laterality</value>
                     <value>Brain-region</value>
                     <value>Sensors</value>
                     <value>Source-analysis-laterality</value>
                     <value>Source-analysis-brain-region</value>
                     <value>Episode-event-count</value>
                  </attribute>
               </node>
               <node>
                  <name>Postictal-EEG-activity</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Brain-laterality</value>
                     <value>Body-part-location</value>
                     <value>Brain-centricity</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Episode-time-context-property</name>
               <description>Additional clinically relevant features related to episodes can be scored under timing and context. If needed, episode duration can be tagged with base schema /Property/Data-property/Data-value/Spatiotemporal-value/Temporal-value/Duration.</description>
               <node>
                  <name>Episode-consciousness</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Episode-consciousness-not-tested</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-consciousness-affected</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-consciousness-mildly-affected</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-consciousness-not-affected</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Episode-awareness</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                     <value>Property-exists</value>
                     <value>Property-absence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Clinical-EEG-temporal-relationship</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Clinical-start-followed-EEG</name>
                     <description>Clinical start, followed by EEG start by X seconds.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>timeUnits</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>EEG-start-followed-clinical</name>
                     <description>EEG start, followed by clinical start by X seconds.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>timeUnits</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Simultaneous-start-clinical-EEG</name>
                  </node>
                  <node>
                     <name>Clinical-EEG-temporal-relationship-notes</name>
                     <description>Clinical notes to annotate the clinical-EEG temporal relationship.</description>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Episode-event-count</name>
                  <description>Number of stereotypical episodes during the recording.</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>State-episode-start</name>
                  <description>State at the start of the episode.</description>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Episode-start-from-sleep</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-start-from-awake</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Episode-postictal-phase</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>unitClass</name>
                        <value>timeUnits</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Episode-prodrome</name>
                  <description>Prodrome is a preictal phenomenon, and it is defined as a subjective or objective clinical alteration (e.g., ill-localized sensation or agitation) that heralds the onset of an epileptic seizure but does not form part of it (Blume et al., 2001). Therefore, prodrome should be distinguished from aura (which is an ictal phenomenon).</description>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-exists</value>
                     <value>Property-absence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Episode-tongue-biting</name>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-exists</value>
                     <value>Property-absence</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Episode-responsiveness</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Property-not-possible-to-determine</value>
                  </attribute>
                  <node>
                     <name>Episode-responsiveness-preserved</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-responsiveness-affected</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Episode-appearance</name>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>Episode-appearance-interactive</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Episode-appearance-spontaneous</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Seizure-dynamics</name>
                  <description>Spatiotemporal dynamics can be scored (evolution in morphology; evolution in frequency; evolution in location).</description>
                  <attribute>
                     <name>requireChild</name>
                  </attribute>
                  <node>
                     <name>Seizure-dynamics-evolution-morphology</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Seizure-dynamics-evolution-frequency</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Seizure-dynamics-evolution-location</name>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Seizure-dynamics-not-possible-to-determine</name>
                     <description>Not possible to determine.</description>
                     <node>
                        <name>#</name>
                        <description>Free text.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>textClass</value>
                        </attribute>
                     </node>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Other-finding-property</name>
            <attribute>
               <name>requireChild</name>
            </attribute>
            <node>
               <name>Artifact-significance-to-recording</name>
               <description>It is important to score the significance of the described artifacts: recording is not interpretable, recording of reduced diagnostic value, does not interfere with the interpretation of the recording.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Recording-not-interpretable-due-to-artifact</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Recording-of-reduced-diagnostic-value-due-to-artifact</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Artifact-does-not-interfere-recording</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Finding-significance-to-recording</name>
               <description>Significance of finding. When normal/abnormal could be labeled with base schema Normal/Abnormal tags.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Finding-no-definite-abnormality</name>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Finding-significance-not-possible-to-determine</name>
                  <description>Not possible to determine.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Finding-frequency</name>
               <description>Value in Hz (number) typed in.</description>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>numericClass</value>
                  </attribute>
                  <attribute>
                     <name>unitClass</name>
                     <value>frequencyUnits</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-amplitude</name>
               <description>Value in microvolts (number) typed in.</description>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>numericClass</value>
                  </attribute>
                  <attribute>
                     <name>unitClass</name>
                     <value>electricPotentialUnits</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-amplitude-asymmetry</name>
               <description>For posterior dominant rhythm: a difference in amplitude between the homologous area on opposite sides of the head that consistently exceeds 50 percent. When symmetrical could be labeled with base schema Symmetrical tag. For sleep: Absence or consistently marked amplitude asymmetry (greater than 50 percent) of a normal sleep graphoelement.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <node>
                  <name>Finding-amplitude-asymmetry-lower-left</name>
                  <description>Amplitude lower on the left side.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Finding-amplitude-asymmetry-lower-right</name>
                  <description>Amplitude lower on the right side.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Finding-amplitude-asymmetry-not-possible-to-determine</name>
                  <description>Not possible to determine.</description>
                  <node>
                     <name>#</name>
                     <description>Free text.</description>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Finding-stopped-by</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-triggered-by</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Finding-unmodified</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Property-not-possible-to-determine</name>
               <description>Not possible to determine.</description>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Property-exists</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Property-absence</name>
               <node>
                  <name>#</name>
                  <description>Free text.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
               </node>
            </node>
         </node>
      </node>
   </schema>
   <unitClassDefinitions>
      <unitClassDefinition>
         <name>accelerationUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^2</value>
         </attribute>
         <unit>
            <name>m-per-s^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>angleUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>radian</value>
         </attribute>
         <unit>
            <name>radian</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>rad</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>degree</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0174533</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>areaUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^2</value>
         </attribute>
         <unit>
            <name>m^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>currencyUnits</name>
         <description>Units indicating the worth of something.</description>
         <attribute>
            <name>defaultUnits</name>
            <value>$</value>
         </attribute>
         <unit>
            <name>dollar</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>$</name>
            <attribute>
               <name>unitPrefix</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>euro</name>
         </unit>
         <unit>
            <name>point</name>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>electricPotentialUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>uv</value>
         </attribute>
         <unit>
            <name>v</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
         </unit>
         <unit>
            <name>Volt</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>frequencyUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>Hz</value>
         </attribute>
         <unit>
            <name>hertz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>Hz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>intensityUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>dB</value>
         </attribute>
         <unit>
            <name>dB</name>
            <description>Intensity expressed as ratio to a threshold. May be used for sound intensity.</description>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>candela</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
         </unit>
         <unit>
            <name>cd</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>jerkUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^3</value>
         </attribute>
         <unit>
            <name>m-per-s^3</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>magneticFieldUnits</name>
         <description>Units used to magnetic field intensity.</description>
         <attribute>
            <name>defaultUnits</name>
            <value>fT</value>
         </attribute>
         <unit>
            <name>tesla</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10^-15</value>
            </attribute>
         </unit>
         <unit>
            <name>T</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10^-15</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>memorySizeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>B</value>
         </attribute>
         <unit>
            <name>byte</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>B</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>physicalLengthUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m</value>
         </attribute>
         <unit>
            <name>foot</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.3048</value>
            </attribute>
         </unit>
         <unit>
            <name>inch</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0254</value>
            </attribute>
         </unit>
         <unit>
            <name>metre</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>m</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>mile</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1609.34</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>speedUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s</value>
         </attribute>
         <unit>
            <name>m-per-s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>mph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.44704</value>
            </attribute>
         </unit>
         <unit>
            <name>kph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.277778</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>temperatureUnits</name>
         <unit>
            <name>degree Celsius</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>oC</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>timeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>s</value>
         </attribute>
         <unit>
            <name>second</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>day</name>
            <attribute>
               <name>conversionFactor</name>
               <value>86400</value>
            </attribute>
         </unit>
         <unit>
            <name>minute</name>
            <attribute>
               <name>conversionFactor</name>
               <value>60</value>
            </attribute>
         </unit>
         <unit>
            <name>hour</name>
            <description>Should be in 24-hour format.</description>
            <attribute>
               <name>conversionFactor</name>
               <value>3600</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>volumeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^3</value>
         </attribute>
         <unit>
            <name>m^3</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>weightUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>g</value>
         </attribute>
         <unit>
            <name>g</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>gram</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
         </unit>
         <unit>
            <name>pound</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
         </unit>
         <unit>
            <name>lb</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
         </unit>
      </unitClassDefinition>
   </unitClassDefinitions>
   <unitModifierDefinitions>
      <unitModifierDefinition>
         <name>deca</name>
         <description>SI unit multiple representing 10^1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>da</name>
         <description>SI unit multiple representing 10^1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>hecto</name>
         <description>SI unit multiple representing 10^2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>h</name>
         <description>SI unit multiple representing 10^2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>kilo</name>
         <description>SI unit multiple representing 10^3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>k</name>
         <description>SI unit multiple representing 10^3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>mega</name>
         <description>SI unit multiple representing 10^6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>M</name>
         <description>SI unit multiple representing 10^6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>giga</name>
         <description>SI unit multiple representing 10^9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>G</name>
         <description>SI unit multiple representing 10^9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>tera</name>
         <description>SI unit multiple representing 10^12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>T</name>
         <description>SI unit multiple representing 10^12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>peta</name>
         <description>SI unit multiple representing 10^15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>P</name>
         <description>SI unit multiple representing 10^15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>exa</name>
         <description>SI unit multiple representing 10^18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>E</name>
         <description>SI unit multiple representing 10^18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zetta</name>
         <description>SI unit multiple representing 10^21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Z</name>
         <description>SI unit multiple representing 10^21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yotta</name>
         <description>SI unit multiple representing 10^24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Y</name>
         <description>SI unit multiple representing 10^24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>deci</name>
         <description>SI unit submultiple representing 10^-1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>d</name>
         <description>SI unit submultiple representing 10^-1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>centi</name>
         <description>SI unit submultiple representing 10^-2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>c</name>
         <description>SI unit submultiple representing 10^-2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>milli</name>
         <description>SI unit submultiple representing 10^-3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>m</name>
         <description>SI unit submultiple representing 10^-3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>micro</name>
         <description>SI unit submultiple representing 10^-6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>u</name>
         <description>SI unit submultiple representing 10^-6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-6</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>nano</name>
         <description>SI unit submultiple representing 10^-9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>n</name>
         <description>SI unit submultiple representing 10^-9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-9</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>pico</name>
         <description>SI unit submultiple representing 10^-12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>p</name>
         <description>SI unit submultiple representing 10^-12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-12</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>femto</name>
         <description>SI unit submultiple representing 10^-15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>f</name>
         <description>SI unit submultiple representing 10^-15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-15</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>atto</name>
         <description>SI unit submultiple representing 10^-18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>a</name>
         <description>SI unit submultiple representing 10^-18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-18</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zepto</name>
         <description>SI unit submultiple representing 10^-21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>z</name>
         <description>SI unit submultiple representing 10^-21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-21</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yocto</name>
         <description>SI unit submultiple representing 10^-24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-24</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>y</name>
         <description>SI unit submultiple representing 10^-24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10^-24</value>
         </attribute>
      </unitModifierDefinition>
   </unitModifierDefinitions>
   <valueClassDefinitions>
      <valueClassDefinition>
         <name>dateTimeClass</name>
         <description>Date-times should conform to ISO8601 date-time format YYYY-MM-DDThh:mm:ss. Any variation on the full form is allowed.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>T</value>
            <value>-</value>
            <value>:</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>nameClass</name>
         <description>Value class designating values that have the characteristics of node names. The allowed characters are alphanumeric, hyphen, and underbar.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>letters</value>
            <value>digits</value>
            <value>_</value>
            <value>-</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>numericClass</name>
         <description>Value must be a valid numerical value.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>E</value>
            <value>e</value>
            <value>+</value>
            <value>-</value>
            <value>.</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>posixPath</name>
         <description>Posix path specification.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>letters</value>
            <value>/</value>
            <value>:</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>textClass</name>
         <description>Value class designating values that have the characteristics of text such as in descriptions.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>letters</value>
            <value>digits</value>
            <value>blank</value>
            <value>+</value>
            <value>-</value>
            <value>:</value>
            <value>;</value>
            <value>.</value>
            <value>/</value>
            <value>(</value>
            <value>)</value>
            <value>?</value>
            <value>*</value>
            <value>%</value>
            <value>$</value>
            <value>@</value>
         </attribute>
      </valueClassDefinition>
   </valueClassDefinitions>
   <schemaAttributeDefinitions>
      <schemaAttributeDefinition>
         <name>allowedCharacter</name>
         <description>A schema attribute of value classes specifying a special character that is allowed in expressing the value of a placeholder. Normally the allowed characters are listed individually. However, the word letters designates the upper and lower case alphabetic characters and the word digits designates the digits 0-9. The word blank designates the blank character.</description>
         <property>
            <name>valueClassProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>conversionFactor</name>
         <description>The multiplicative factor to multiply these units to convert to default units.</description>
         <property>
            <name>unitProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>defaultUnits</name>
         <description>A schema attribute of unit classes specifying the default units to use if the placeholder has a unit class but the substituted value has no units.</description>
         <property>
            <name>unitClassProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>extensionAllowed</name>
         <description>A schema attribute indicating that users can add unlimited levels of child nodes under this tag. This tag is propagated to child nodes with the exception of the hashtag placeholders.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>recommended</name>
         <description>A schema attribute indicating that the event-level HED string should include this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>relatedTag</name>
         <description>A schema attribute suggesting HED tags that are closely related to this tag. This attribute is used by tagging tools.</description>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>requireChild</name>
         <description>A schema attribute indicating that one of the node elements descendants must be included when using this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>required</name>
         <description>A schema attribute indicating that every event-level HED string should include this tag.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnit</name>
         <description>A schema attribute indicating that this unit element is an SI unit and can be modified by multiple and submultiple names. Note that some units such as byte are designated as SI units although they are not part of the standard.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitModifier</name>
         <description>A schema attribute indicating that this SI unit modifier represents a multiple or submultiple of a base unit rather than a unit symbol.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitSymbolModifier</name>
         <description>A schema attribute indicating that this SI unit modifier represents a multiple or submultiple of a unit symbol rather than a base symbol.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitModifierProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>suggestedTag</name>
         <description>A schema attribute that indicates another tag  that is often associated with this tag. This attribute is used by tagging tools to provide tagging suggestions.</description>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>tagGroup</name>
         <description>A schema attribute indicating the tag can only appear inside a tag group.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>takesValue</name>
         <description>A schema attribute indicating the tag is a hashtag placeholder that is expected to be replaced with a user-defined value.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>topLevelTagGroup</name>
         <description>A schema attribute indicating that this tag (or its descendants) can only appear in a top-level tag group. A tag group can have at most one tag with this attribute.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unique</name>
         <description>A schema attribute indicating that only one of this tag or its descendants can be used  in the event-level HED string.</description>
         <property>
            <name>boolProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitClass</name>
         <description>A schema attribute specifying which unit class this value tag belongs to.</description>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitPrefix</name>
         <description>A schema attribute applied specifically to unit elements to designate that the unit indicator is a prefix (e.g., dollar sign in the currency units).</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitSymbol</name>
         <description>A schema attribute indicating this tag is an abbreviation or symbol representing a type of unit. Unit symbols represent both the singular and the plural and thus cannot be pluralized.</description>
         <property>
            <name>boolProperty</name>
         </property>
         <property>
            <name>unitProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>valueClass</name>
         <description>A schema attribute specifying which value class this value tag belongs to.</description>
      </schemaAttributeDefinition>
   </schemaAttributeDefinitions>
   <propertyDefinitions>
      <propertyDefinition>
         <name>boolProperty</name>
         <description>Indicates that the schema attribute represents something that is either true or false and does not have a value. Attributes without this value are assumed to have string values.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitClassProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to unit classes.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitModifierProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to unit modifier classes.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to units within a unit class.</description>
      </propertyDefinition>
      <propertyDefinition>
         <name>valueClassProperty</name>
         <description>Indicates that the schema attribute is meant to be applied to value classes.</description>
      </propertyDefinition>
   </propertyDefinitions>
   <epilogue>The Standardized Computer-based Organized Reporting of EEG (SCORE) is a standard terminology for scalp EEG data assessment designed for use in clinical practice that may also be used for research purposes.
The SCORE standard defines terms for describing phenomena observed in scalp EEG data. It is also potentially applicable (with some suitable extensions) to EEG recorded in critical care and neonatal settings.
The SCORE standard received European consensus and has been endorsed by the European Chapter of the International Federation of Clinical Neurophysiology (IFCN) and the International League Against Epilepsy (ILAE) Commission on European Affairs.
A second revised and extended version of SCORE achieved international consensus.
[1] Beniczky, Sandor, et al. &quot;Standardized computer based organized reporting of EEG: SCORE.&quot; Epilepsia 54.6 (2013).
[2] Beniczky, Sandor, et al. &quot;Standardized computer based organized reporting of EEG: SCORE second version.&quot; Clinical Neurophysiology 128.11 (2017). 
TPA, January 2023</epilogue>
</HED>
